module.exports = __webpack_public_path__ + "img/basic_bg.04777d32.jpg";